// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: #fff;
}

.login_login-section__ZhPCe {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
}

.login_login-bg__HV1GU{
    background-color: #f2f3f6;
    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75);
    border: 1px solid #ced4da;
}
.login_frm-chck-pd-lft__aqPHa{
        padding-left: 0 !important;
}
@media screen and (max-width:767px) {
    .login_login-bg__HV1GU{
        padding: 20px !important;
    }
    .login_user-register__YEzDo{
        margin: 0 !important;
    }
    .login_login-help__w2aPF{
        text-align: left;
        margin-top: 20px;
    }

}
@media screen and (min-width:768px) and (max-width:1024px){
    .login_user-register__YEzDo{
        margin: 0 !important;
    }
}
.login_admin-login__Nk74c {
    width: 100%;
    padding: 40px;
    margin: 0;
    border-radius: 8px;
    min-height: auto;
}

@media screen and (max-width: 576px) {
    .login_admin-login__Nk74c {
        padding: 30px 20px;
    }
}
    
    @media screen and (max-width:767px) {
        .login_d-mob-block__I3QYM{
            display: block;;
        }
        h2{
            text-align: left !important;
        }
        h4{
            font-weight: 700 !important;
        }
        .login_login-form__cqDjD .login_forgot-pwd__hOBzP{
            float: left !important;
        }
        .login_login-form__cqDjD label{
            margin-top: 20px;
            margin-left: 10px;
        }
     
        .login_download-app__\\+KAf\\+{
            flex-direction: column !important;    
            align-items: center;        
        }
        .login_download-app__\\+KAf\\+ a{
            margin-bottom: 20px !important;
        }
        .login_contact-information__7U6pP {
            margin-top: 0px !important;
        }
    }

    .login_login-head__OUnXN h1 {
        font-size: 44px;
        font-weight: 300;
        color: #4f785f !important;
        margin-bottom: 24px;
    }
    
    @media screen and (max-width: 576px) {
        .login_login-head__OUnXN h1 {
            font-size: 32px;
        }
    }
    
    .login_login-head__OUnXN span {
        font-size: 20px;
        font-weight: 300;
        color: #4f785f !important;
        margin-bottom: 24px;
        display: block;
    }
    
    @media screen and (max-width: 576px) {
        .login_login-head__OUnXN span {
            font-size: 16px;
        }
    }

    .login_login-form__cqDjD {
        margin-top: 20px;
    }
    
    .login_login-form__cqDjD label {
        display: block;
        font-size: 20px;
        color: #222222!important;
        margin-bottom: 5px;
        font-weight: 300;
        line-height: 110%;
    }

    .login_login-form__cqDjD input[type=text],
    .login_login-form__cqDjD input[type=password] {
        width: 100%;
        padding: 8px 18px;
        margin-bottom: 15px;
        border: 1px solid #1c1c1c;
        font-size: 16px;
        border-radius: unset;
        color: #1c1c1c;
    }

    .login_login-form__cqDjD .login_login-btn__7JBf6 {
        font-weight: 400;
        font-size: 26px;
        line-height: 120%;
        letter-spacing: normal;
        text-align: center;
        text-transform: capitalize;
        background-color: #ffb034!important;
        color: #fff;
        min-width: 177px;
        height: 48px;
        border-radius: 4px;
        border:0;
        width: 100%;
        margin-top: 20px;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    
    @media screen and (max-width: 576px) {
        .login_login-form__cqDjD .login_login-btn__7JBf6 {
            font-size: 20px;
            height: 44px;
        }
    }
    .login_login-form__cqDjD .login_login-btn__7JBf6:hover {
        text-decoration: underline;
    }

    .login_login-form__cqDjD .login_form-check-input__M\\+87S:checked {
        background-color: #000;
        border-color: #000;
    }

    .login_login-form__cqDjD .login_form-check-input__M\\+87S:focus {
        box-shadow: none;
    }

    .login_login-form__cqDjD .login_form-check-input__M\\+87S {
        margin-top: 0;
        width: 20px;
        height: 20px;
        border-radius: 0;
        border:1px solid #1c1c1c;
        margin-left: 0px !important
    }

    .login_login-form__cqDjD .login_forgot-pwd__hOBzP {
        float: right;
        font-size: 20px;
        color: #ffb034!important;
        text-decoration: underline;
        font-weight: 300;
        margin-top: -2px;
    }

    .login_login-form__cqDjD .login_forgot-pwd-div__wjjZc {
        display: flex;
        justify-content: space-between;
    }


.login_admin-login__Nk74c .login_login-form__cqDjD input[type=text],
.login_admin-login__Nk74c .login_login-form__cqDjD input[type=email], 
.login_admin-login__Nk74c .login_login-form__cqDjD input[type=password] {
    width: 100%;
    padding: 8px 18px;
    margin-bottom: 15px;
    border: 1px solid #ced4da;
    font-size: 16px;
    font-family: "Inter", sans-serif;
    border-radius: unset;
    color: #222222;
}
`, "",{"version":3,"sources":["webpack://./src/styles/login/login.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;IAC/C,yBAAyB;AAC7B;AACA;QACQ,0BAA0B;AAClC;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,oBAAoB;IACxB;AACJ;AACA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;IAEI;QACI;YACI,cAAc;QAClB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,gBAAgB;YAChB,iBAAiB;QACrB;;QAEA;YACI,iCAAiC;YACjC,mBAAmB;QACvB;QACA;YACI,8BAA8B;QAClC;QACA;YACI,0BAA0B;QAC9B;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,wBAAwB;QACxB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;QACX,iBAAiB;QACjB,mBAAmB;QACnB,yBAAyB;QACzB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;QAClB,0BAA0B;QAC1B,mCAAmC;QACnC,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI;YACI,eAAe;YACf,YAAY;QAChB;IACJ;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,wBAAwB;QACxB;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,wBAAwB;QACxB,0BAA0B;QAC1B,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;;AAGJ;;;IAGI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,cAAc;AAClB","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    background: #fff;\n}\n\n.login-section {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 0;\n}\n\n.login-bg{\n    background-color: #f2f3f6;\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75);\n    border: 1px solid #ced4da;\n}\n.frm-chck-pd-lft{\n        padding-left: 0 !important;\n}\n@media screen and (max-width:767px) {\n    .login-bg{\n        padding: 20px !important;\n    }\n    .user-register{\n        margin: 0 !important;\n    }\n    .login-help{\n        text-align: left;\n        margin-top: 20px;\n    }\n\n}\n@media screen and (min-width:768px) and (max-width:1024px){\n    .user-register{\n        margin: 0 !important;\n    }\n}\n.admin-login {\n    width: 100%;\n    padding: 40px;\n    margin: 0;\n    border-radius: 8px;\n    min-height: auto;\n}\n\n@media screen and (max-width: 576px) {\n    .admin-login {\n        padding: 30px 20px;\n    }\n}\n    \n    @media screen and (max-width:767px) {\n        .d-mob-block{\n            display: block;;\n        }\n        h2{\n            text-align: left !important;\n        }\n        h4{\n            font-weight: 700 !important;\n        }\n        .login-form .forgot-pwd{\n            float: left !important;\n        }\n        .login-form label{\n            margin-top: 20px;\n            margin-left: 10px;\n        }\n     \n        .download-app{\n            flex-direction: column !important;    \n            align-items: center;        \n        }\n        .download-app a{\n            margin-bottom: 20px !important;\n        }\n        .contact-information {\n            margin-top: 0px !important;\n        }\n    }\n\n    .login-head h1 {\n        font-size: 44px;\n        font-weight: 300;\n        color: #4f785f !important;\n        margin-bottom: 24px;\n    }\n    \n    @media screen and (max-width: 576px) {\n        .login-head h1 {\n            font-size: 32px;\n        }\n    }\n    \n    .login-head span {\n        font-size: 20px;\n        font-weight: 300;\n        color: #4f785f !important;\n        margin-bottom: 24px;\n        display: block;\n    }\n    \n    @media screen and (max-width: 576px) {\n        .login-head span {\n            font-size: 16px;\n        }\n    }\n\n    .login-form {\n        margin-top: 20px;\n    }\n    \n    .login-form label {\n        display: block;\n        font-size: 20px;\n        color: #222222!important;\n        margin-bottom: 5px;\n        font-weight: 300;\n        line-height: 110%;\n    }\n\n    .login-form input[type=text],\n    .login-form input[type=password] {\n        width: 100%;\n        padding: 8px 18px;\n        margin-bottom: 15px;\n        border: 1px solid #1c1c1c;\n        font-size: 16px;\n        border-radius: unset;\n        color: #1c1c1c;\n    }\n\n    .login-form .login-btn {\n        font-weight: 400;\n        font-size: 26px;\n        line-height: 120%;\n        letter-spacing: normal;\n        text-align: center;\n        text-transform: capitalize;\n        background-color: #ffb034!important;\n        color: #fff;\n        min-width: 177px;\n        height: 48px;\n        border-radius: 4px;\n        border:0;\n        width: 100%;\n        margin-top: 20px;\n        cursor: pointer;\n        transition: all 0.3s ease;\n    }\n    \n    @media screen and (max-width: 576px) {\n        .login-form .login-btn {\n            font-size: 20px;\n            height: 44px;\n        }\n    }\n    .login-form .login-btn:hover {\n        text-decoration: underline;\n    }\n\n    .login-form .form-check-input:checked {\n        background-color: #000;\n        border-color: #000;\n    }\n\n    .login-form .form-check-input:focus {\n        box-shadow: none;\n    }\n\n    .login-form .form-check-input {\n        margin-top: 0;\n        width: 20px;\n        height: 20px;\n        border-radius: 0;\n        border:1px solid #1c1c1c;\n        margin-left: 0px !important\n    }\n\n    .login-form .forgot-pwd {\n        float: right;\n        font-size: 20px;\n        color: #ffb034!important;\n        text-decoration: underline;\n        font-weight: 300;\n        margin-top: -2px;\n    }\n\n    .login-form .forgot-pwd-div {\n        display: flex;\n        justify-content: space-between;\n    }\n\n\n.admin-login .login-form input[type=text],\n.admin-login .login-form input[type=email], \n.admin-login .login-form input[type=password] {\n    width: 100%;\n    padding: 8px 18px;\n    margin-bottom: 15px;\n    border: 1px solid #ced4da;\n    font-size: 16px;\n    font-family: \"Inter\", sans-serif;\n    border-radius: unset;\n    color: #222222;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-section": `login_login-section__ZhPCe`,
	"login-bg": `login_login-bg__HV1GU`,
	"frm-chck-pd-lft": `login_frm-chck-pd-lft__aqPHa`,
	"user-register": `login_user-register__YEzDo`,
	"login-help": `login_login-help__w2aPF`,
	"admin-login": `login_admin-login__Nk74c`,
	"d-mob-block": `login_d-mob-block__I3QYM`,
	"login-form": `login_login-form__cqDjD`,
	"forgot-pwd": `login_forgot-pwd__hOBzP`,
	"download-app": `login_download-app__+KAf+`,
	"contact-information": `login_contact-information__7U6pP`,
	"login-head": `login_login-head__OUnXN`,
	"login-btn": `login_login-btn__7JBf6`,
	"form-check-input": `login_form-check-input__M+87S`,
	"forgot-pwd-div": `login_forgot-pwd-div__wjjZc`
};
export default ___CSS_LOADER_EXPORT___;
